import { Plan } from "./Plan.type";
import { Role } from "./Role.type";

type ObjectId = {
    $oid: string;
};

export type UserFromToken = {
    _id: string;
    companies?: ObjectId[];
    email?: string;
    firstName?: string;
    lastName?: string;
    type?: UserTypes;
    userId?: ObjectId;
    organizationId?: string;
    phone?: string;
    updatedAt?: string;
    isDeleted?: boolean;
    showStartingGuide?: boolean;
    companyType?: string;
    targetOrganizationId?: string;
};

export type User = {
    _id: string;
    email: string;
    phone: string;
    accountId: string;
    companyId: string;
    organizationId: string;
    companies: string[];
    type: UserTypes;
    role: Role;
    firstName?: string;
    lastName?: string;
    pincode?: string;
    name: string;
    outlets?: string[];
    userId?: string;
    plan?: Plan;
    isDeleted?: boolean;
};

export enum UserTypes {
    OWNER = "owner",
    ORG_USER = "organization_user",
    ORG_OWNER = "organization_owner",
    FINAL_USER = "final_user",
    FINAL_OWNER = "final_owner",
    EMPLOYEE = "employee",
    SUPER_ADMIN = "super_admin",
    MANAGER = "manager",
    ADMIN = "admin",
    ASSISTANT_MANAGER = "assistant",
    CASHIER = "cashier",
    RESELLER = "reseller"
}

export const FINAL_USERS = [UserTypes.FINAL_USER, UserTypes.FINAL_OWNER];

export const ORG_USERS = [UserTypes.ORG_USER, UserTypes.ORG_OWNER];

export const COMPANY_USERS = [UserTypes.OWNER, UserTypes.ADMIN, UserTypes.MANAGER, UserTypes.ASSISTANT_MANAGER, UserTypes.CASHIER];

export type StripeUser = {
    companyId: string;
    companyName: string;
    name: string;
    email: string;
    organizationCategory: string;
    referralSource: string;
};
